import { motion } from "framer-motion";
import WhatsAppIcon from "./WhatsAppIcon";
import { ease, } from "./Reveal";
import { WHATSAPP_URL } from "@/lib/scroll";

export default function FloatingWhats() {
  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Conversar no WhatsApp"
      data-testid="float-whatsapp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2.2, duration: 0.6, ease }}
      whileHover={{ scale: 1.1, rotate: 8 }}
      className="fixed bottom-5 right-5 z-[60] inline-flex size-14 items-center justify-center rounded-full bg-terra text-cream shadow-xl shadow-olive-deep/40"
    >
      <WhatsAppIcon className="size-7" />
    </motion.a>
  );
}
